import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { onboardingSlideMessage as orgConfig } from 'org/configs/modules.config';
import {
  ONBOARDING_SLIDE_MESSAGE_GET_SUCCESS, ONBOARDING_SLIDE_MESSAGE_GET_FAILURE,
} from '../actions/types';
import {
  WELCOME_MESSAGE, EMAIL_MESSAGE, BUTTON_MOBILE_MESSAGE, BUTTON_DESKTOP_MESSAGE,
} from '../utils/constants';

const defaultConfig = {
  defaults: {
    api: {
      getParams: (slide) => {
        const offerTags = {
          [WELCOME_MESSAGE]: 'onboarding-welcome-message',
          [EMAIL_MESSAGE]: 'onboarding-email-message',
          [BUTTON_MOBILE_MESSAGE]: 'onboarding-mobile-button-message',
          [BUTTON_DESKTOP_MESSAGE]: 'onboarding-desktop-button-message',
        };

        return {
          offer_tag: offerTags[slide],
          fields: ['termsAndConditions', 'assets'].join(','),
        };
      },
      options: {
        success: ONBOARDING_SLIDE_MESSAGE_GET_SUCCESS,
        failure: ONBOARDING_SLIDE_MESSAGE_GET_FAILURE,
        cache: { isEnabled: true, isPublishedData: true },
      },
    },
    shouldUseSlideMessage: false,
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
